<template>
  <fieldset class="custom-fieldset">
    <legend>Nocleg nr {{ partIndex + 1 }}</legend>
    <v-row>
      <v-col class="pa-1" md="3" cols="12">
        <v-text-field :rules="[isRequired]" label="Nazwa hotelu*" v-model="contextPart.name" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="3" cols="12">
        <v-rating :rules="[isRequired]" class="small-rating" v-model="contextPart.hotel_class" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="6" cols="12">
        <v-text-field :rules="[isRequired]" label="Adres*" v-model="contextPart.address" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Termin zakwaterowania*"
          v-model="contextPart.start_date"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Termin wykwaterowania*"
          v-model="contextPart.end_date"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          :rules="[isRequired]"
          label="Liczba osób w pokoju*"
          v-model="contextPart.person_per_room"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Liczba pokoi*" v-model="contextPart.rooms" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field :rules="[isRequired]" label="Typ pokoju*" v-model="contextPart.room_type" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
      <v-col class="pa-1" md="4" cols="12">
        <v-text-field label="Dodatkowe usługi" v-model="contextPart.additional_services" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field label="Średnia kwota za dobę" v-model="contextPart.price_per_day" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>

      <v-col class="pa-1" md="4" cols="12">
        <v-text-field
          label="Termin bezkosztowej anulacji"
          placeholder="Oferta bezzwrotna"
          v-model="contextPart.cancel_until"
          :readonly="$store.state.AdminTravelService.isOfferReadonly"
        />
      </v-col>

      <v-col class="pa-1" cols="12">
        <v-textarea label="Komentarz" v-model="contextPart.comment" :readonly="$store.state.AdminTravelService.isOfferReadonly" />
      </v-col>
    </v-row>
  </fieldset>
</template>

<script>
export default {
  name: "HotelForm",
  props: {
    part: {
      required: true
    },
    partIndex: {
      required: true,
      type: Number
    }
  },
  computed: {
    contextPart: {
      get() {
        return this.part;
      },
      set(val) {
        this.$emit("update:part", val);
      }
    }
  },
  methods: {
    isRequired(v) {
      return (v != null && v.length > 0) || "Pole wymagane";
    }
  }
};
</script>

<style scoped></style>
